@if (dataLoaded()) {
  <div class="stu-space-detail-student">
    <div class="pre-page spen-mod-heading lv-1">
      <div class="heading-text pre-page-text">
        <div class="pre-first-block">
          <a [routerLink]="['/spaces/student']"><i class="fa fa-chevron-left"></i></a>
          <div class="pre-space-color" [style.background-color]="spaceDetail.color_code"></div>
          <div class="pre-text-info">
            <p>{{ spaceDetail.name }}</p>
            <p>
              <span>生徒{{ spaceDetail.users_count }}</span>
              <span>先生{{ spaceDetail.teachers_count }}</span>
              @if (!spaceDetail.student_can_comment_other) {
                <img src="/assets/images/icons/icon_comment_off.svg" />
              }
            </p>
          </div>
        </div>
      </div>
    </div>
    @if (filterService.filtered) {
      <div class="filtered-category">
        <div class="change-filter">
          <a class="spen-util-link" (click)="filterService.showFilter()"><i class="fa fa-search"></i>検索条件を変更</a>
        </div>
        <div class="category-detail">
          <span class="category-name">検索条件：{{ filterService.messageFilter }}</span>
          <a class="remove-filter spen-util-link" (click)="removeFilter()">解除</a>
        </div>
      </div>
    } @else {
      <div class="not-filtered-category">
        <a class="spen-util-link" (click)="filterService.showFilter()"><i class="fa fa-search"></i>検索</a>
      </div>
    }
    <div class="activity-records-list">
      @if (activityRecordsCount > 0) {
        <div class="quantity">
          <p>{{ activityRecordsCount }}件</p>
        </div>
      }
      @if (dataLoaded) {
        @if (activityRecordsCount > 0) {
          <div class="space-content">
            <ul class="space-flex-list">
              @for (activityRecord of activityRecords; track activityRecord.id; let isFirst = $first) {
                <li class="list-item" (click)="onClickActitityDetail(activityRecord)" [class.is-first]="isFirst">
                  <app-student-public-activity-item [activityRecord]="activityRecord"></app-student-public-activity-item>
                </li>
              }
            </ul>
            <div class="block-footer">
              @if (showPagination) {
                <div class="pagination">
                  <spen-paginator [length]="page().total_pages" [pageIndex]="page().current_page - 1" (page)="pageChanged($event)" />
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="null-content">
            <p class="text">活動記録はありません。</p>
          </div>
        }
      } @else {
        <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
      }
    </div>
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
@if (filterService.isShowingFilter) {
  <app-student-filter-by-cross-review (submitFilter)="changeFilter($event)"> </app-student-filter-by-cross-review>
}
